import { Navigate, useNavigate } from 'react-router';
import { LeadForm } from '../components/LeadForm';
import { useAuth } from '@/hooks/useAuth';
import { usePageTitle } from '@/hooks/usePageTitle';
import { Permissions } from '@/types';

/**
 * Focused, chrome-less New Lead entry route (/leads/new).
 *
 * Rendered outside AppLayout so intake staff get a distraction-free
 * full-screen form: no header navigation, no all-leads dropdown, no
 * lead management buttons. Save and Cancel come from LeadForm itself;
 * this page owns navigation on success/cancel.
 */
export function NewLeadPage() {
  const navigate = useNavigate();
  const { hasPermission } = useAuth();

  usePageTitle('New Lead');

  // Without leads:create there is nothing to do here — and, being
  // chrome-less, the page has no navigation to escape from. Redirect
  // back to the leads list instead of trapping the user in a
  // read-only empty form.
  if (!hasPermission(Permissions.LeadsCreate)) {
    return <Navigate to="/leads" replace />;
  }

  return (
    <main className="min-h-screen bg-background p-8">
      <h1 className="sr-only">New Lead</h1>
      <LeadForm
        mode="create"
        onSuccess={(lead) => navigate(`/leads/${lead.id}`)}
        onCancel={() => navigate('/leads')}
      />
    </main>
  );
}
